var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-summary" }, [
    _vm.preBookingData
      ? _c("div", { staticClass: "card shadow-sm" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 p-0" }, [
                  _c("h3", { staticClass: "reply-name" }, [
                    _vm._v(_vm._s(_vm.$t("message.booking.summary.title")))
                  ]),
                  _vm._v(" "),
                  _c("b", [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.serviceParentName(
                            _vm.preBookingData.service_id,
                            _vm.globalState.services
                          )
                        )
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 p-0 mt-1" }, [
                  _vm.preBookingData.service_id === 1
                    ? _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getWorkHours()) +
                            "\n          "
                        )
                      ])
                    : _vm.preBookingData.service_items
                    ? _c(
                        "span",
                        _vm._l(_vm.preBookingData.service_items, function(
                          serviceItem
                        ) {
                          return _c("div", [
                            _vm._v(
                              "\n              - " +
                                _vm._s(_vm._f("multiLangName")(serviceItem)) +
                                ": " +
                                _vm._s(serviceItem.count) +
                                " " +
                                _vm._s(
                                  _vm._f("multiLangName")(serviceItem.item_unit)
                                ) +
                                "\n            "
                            )
                          ])
                        }),
                        0
                      )
                    : _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("multiLangName")(
                                _vm.globalState.services[
                                  _vm.preBookingData.service_id
                                ]
                              )
                            ) +
                            "\n          "
                        )
                      ])
                ]),
                _vm._v(" "),
                _vm.preBookingData.subscription_type_id
                  ? _c("div", { staticClass: "col-12 p-0 mt-2" }, [
                      _c("span", { staticClass: "text-orange" }, [
                        _c("i", { staticClass: "fal fa-calendar-alt" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("message.subscription.title")) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          " - " +
                            _vm._s(
                              _vm._f("multiLangName")(_vm.subscriptionType)
                            ) +
                            " (" +
                            _vm._s(_vm.subscriptionType.num_per_month) +
                            " " +
                            _vm._s(_vm.$t("message.times")) +
                            ")"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("subscriptionStartDate")(
                                _vm.preBookingData.cleaning_date
                              )
                            ) +
                            " • " +
                            _vm._s(_vm.preBookingData.cleaning_time) +
                            "\n          "
                        )
                      ])
                    ])
                  : _vm.preBookingData.package_type
                  ? _c("div", { staticClass: "col-12 p-0 mt-2" }, [
                      _c("span", { staticClass: "text-orange" }, [
                        _c("i", { staticClass: "fal fa-layer-group" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("message.my_reservations.package")) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          " - " +
                            _vm._s(
                              _vm._f("multiLangName")(
                                _vm.preBookingData.package_type
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.preBookingData.package_type.category === "flexible"
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.new_booking.package_count",
                                    {
                                      count:
                                        _vm.preBookingData.package_type_discount
                                          .booking_qty
                                    }
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        : _vm.preBookingData.package_type.category ===
                          "unlimited"
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.new_booking.package_count",
                                    {
                                      count:
                                        _vm.preBookingData.multi_dates_times
                                          .length
                                    }
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("section", { staticClass: "mt-2 pb-0 mb-0" }, [
                        _c(
                          "ul",
                          { staticClass: "ml-4 pb-0 mb-0" },
                          _vm._l(_vm.preBookingData.multi_dates_times, function(
                            selectedDateTime
                          ) {
                            return _c(
                              "li",
                              { staticClass: "text-order-title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("shortDate")(selectedDateTime)
                                    ) +
                                    " • " +
                                    _vm._s(
                                      _vm._f("onlyTime")(selectedDateTime)
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _c("div", { staticClass: "col-12 p-0 mt-2" }, [
                      _vm.preBookingData.cleaning_date
                        ? _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("summaryCleaningDate")(
                                    _vm.preBookingData.cleaning_date
                                  )
                                ) +
                                " • " +
                                _vm._s(_vm.preBookingData.cleaning_time) +
                                "\n          "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.new_booking.booking_type_flexible"
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 p-0 mt-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("multiLangName")(
                          _vm.globalState.cities[_vm.preBookingData.province_id]
                        )
                      ) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              !_vm._.isEmpty(_vm.selectedProfessional)
                ? _c("section", [
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("message.booking.summary.your_cleaner"))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-start align-items-center"
                      },
                      [
                        _c(
                          "div",
                          [
                            _vm.selectedProfessional
                              ? [
                                  _c("professional-picture", {
                                    attrs: {
                                      professional: _vm.selectedProfessional,
                                      imgClass: "img-fluid",
                                      imgSize: 44,
                                      "badge-size": 20
                                    }
                                  })
                                ]
                              : [
                                  _c("img", {
                                    attrs: {
                                      src: "/static/img/unselected-cleaner.png",
                                      width: "56",
                                      alt: "unselected cleaner"
                                    }
                                  })
                                ]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.selectedProfessional
                          ? _c("div", { staticClass: "pl-3" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("firstName")(
                                      _vm.selectedProfessional.name
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _vm.$route.path === "/booking/choose-cleaner"
                                ? _c("p", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-remove-cleaner",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.unselectProfessional.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-times"
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.summary.remove"
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.distance &&
                    _vm.acceptedDistance &&
                    _vm.distance > _vm.acceptedDistance
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex border border-warning justify-content-start align-items-top -bg-warning-soft rounded-all p-2 mt-2 text-small"
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "pl-2" }, [
                              _c("div", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.distance_warning_title"
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm._f("distance")(_vm.distance))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.distance_warning_subtitle"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("checkout-cost"),
              _vm._v(" "),
              _c("label", { staticClass: "mt-4" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.booking.summary.all_inclusive_title"))
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-remark" }, [
                _vm.preBookingData.service_id === 1
                  ? _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "message.booking.summary.all_inclusive_general_cleaning"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm.preBookingData.service_id >= 2 &&
                    _vm.preBookingData.service_id <= 6
                  ? _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "message.booking.summary.all_inclusive_ironing"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "message.booking.summary.all_inclusive_transportation"
                            )
                          ) +
                          "\n        "
                      )
                    ])
              ])
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-exclamation-circle text-danger fa-lg" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c4e4876", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c4e4876","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/SummaryBookingDesktop.vue
// module id = 1856
// module chunks = 0